import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../apiClientContext";
import { searchEntityCandidates, resolveEntity } from "./api";

const entityKeys = {
    candidates: (type: string, query: string) =>
        ["entity-candidates", type, query] as const,
    resolve: (type: string, id: string) =>
        ["entity-resolve", type, id] as const,
};

export function useEntityCandidates(type: string, query: string, top = 5) {
    const client = useApiClient();
    const trimmed = useMemo(() => query.trim(), [query]);

    return useQuery({
        queryKey: entityKeys.candidates(type, trimmed),
        queryFn: () => searchEntityCandidates(client, type, trimmed, top),
        enabled: type.length > 0 && trimmed.length >= 2,
        staleTime: 30_000,
    });
}

export function useEntityResolve(type: string, id: string, enabled = true) {
    const client = useApiClient();
    const trimmedId = useMemo(() => id.trim(), [id]);

    return useQuery({
        queryKey: entityKeys.resolve(type, trimmedId),
        queryFn: () => resolveEntity(client, type, trimmedId),
        enabled: enabled && type.length > 0 && trimmedId.length > 0,
        staleTime: 60_000,
    });
}
